import { CreditsQuery } from "@generated"
import { getGraphqlClient } from "@lib/graphql-client"
import { useQuery } from "@tanstack/react-query"

export type UseCreditsPayload = {
  data?: CreditsQuery["credits"]
  refetch: () => void
}
const { sdk } = getGraphqlClient()

export const useCredits = (): UseCreditsPayload => {
  const { data, refetch } = useQuery({
    queryFn: async () => sdk.Credits(),
    queryKey: ["credits"],
  })

  return { data: data?.credits, refetch }
}
